let storageHelper = {};

storageHelper.setScopedVar = function(scope, scopedSettings) {
    window.P2A.Helpers.LocalStorageLib.setLocalVar(scope, scopedSettings);
};

storageHelper.setLocalStorageVar = function(commit, val, commitKey, scope) {
    if (typeof commit === "function") {
      commit(commitKey, val);
    }

    //Save it to local storage for persistence throughout our session
    let scopedSettings = window.P2A.Helpers.LocalStorageLib.getJSON(scope);
    scopedSettings[commitKey] = val;

    storageHelper.setScopedVar(scope, scopedSettings);
}

storageHelper.setStoreFromLocalStorage = function($store, scope, scopeNamespace = '') {

    let localStorageScope = scopeNamespace.length == 0 ? scope : `${scopeNamespace}/${scope}`;

    let scopedSettings = window.P2A.Helpers.LocalStorageLib.getJSON(localStorageScope);

    Object.keys(scopedSettings).forEach((setting) => {
        $store.dispatch(`${scope}/${setting}`, scopedSettings[setting]);
    });
}

storageHelper.resetState = function(commit, defaultState, scope) {
    Object.keys(defaultState).forEach((settingName) => {
        storageHelper.setLocalStorageVar(commit, defaultState[settingName], settingName, scope);
    });
}

export default storageHelper;
